module.exports = __webpack_public_path__ + "img/banner_house_landing.61913305.png";